import { useMemo } from 'react';
import { Column } from 'react-table';
import { useCommonTranslation } from '../../../hooks/i18n/useCommonTranslation';
import { WaitingListCountDataEntry } from '../../../services/waitingList';
import { TableHeadStyle } from '../../../styles/Typography';
import { IObjectWithId } from '../../../types/table';
import { formatDateOnlySite, parseIsoDate } from '../../../utils/dateUtil';
import { getNewColumnWidth } from '../../../utils/table';
import { useWaitingListCount } from '../../../query/waitingList';

type WaitingListCountDataEntryWithId = WaitingListCountDataEntry &
  IObjectWithId;

export const useWaitingListStatsColumns = () => {
  const { t } = useCommonTranslation();
  return useMemo(() => {
    return [
      {
        Header: t('date'),
        accessor: (entry) => formatDateOnlySite(parseIsoDate(entry.date)),
        cellStyle: TableHeadStyle,
        width: getNewColumnWidth(20),
        disableSortBy: true,
      },
      {
        Header: t('number-of-patients'),
        accessor: 'count',
        cellStyle: TableHeadStyle,
        width: getNewColumnWidth(15),
        disableSortBy: true,
      },
    ] as Column<WaitingListCountDataEntryWithId>[];
  }, [t]);
};

export const useWaitingListStatsData = () => {
  const { data: countResponse, isFetching: isCountFetching } =
    useWaitingListCount();

  const { entries, totalCount } = useMemo(() => {
    const entries = countResponse?.data?.data;
    if (!entries) {
      return { totalCount: 0 };
    }
    return {
      entries: entries.map((entry) => ({
        ...entry,
        id: entry.date,
      })),
      totalCount: entries.reduce((sum, entry) => sum + entry.count, 0),
    };
  }, [countResponse]);

  return {
    entries,
    totalCount,
    isLoading: isCountFetching,
  };
};
